import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { consent } from ".";
/**
 * `window.consentApi.consentAll`: Check if a set of given technical information (e.g. HTTP Cookie, LocalStorage, ...)
 * have a consent. This is similar to `window.consentApi.consent` but for multiple cookies.
 */

function consentAll(technicalDefinitions) {
  return Promise.all(technicalDefinitions.map(function (args) {
    return consent.apply(void 0, _toConsumableArray(args));
  }));
}

export { consentAll };